<template>
  <div class="campaign-info" style="overflow:auto;-webkit-overflow-scrolling:touch">
    <iframe ref='iframe'
      src="https://d.bmb.jp/bm/p/f/tf.php?id=bm35275ca&task=regist"
      frameborder='0'>
    </iframe>
    <div class="btn-footer">
      <div class="actions">
        <button type='button' @click='finishCampaign' class='btn'>スキップ</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['order'],
  name: "CampaignInfo",
  created: function(){
    if (!this.order) this.$router.push({name: 'orderSteps'})
  },
  mounted: function() {
    this.$$.context({
      title: "ID:"+this.$route.params.id,
      previousRouteName: 'orderSteps',
    });
  },
  methods: {
    finishCampaign: function() {
      this.$route.params['finishCampaign'] = true;
      this.$router.push({
        name:   'payment',
        params: this.$route.params
      });
    }
  }
}
</script>

<style lang='scss'>
.campaign-info {
  height: 100%;
  iframe {
    width: 1px;
    height: 1px;
    min-width: 100%;
    max-width: 100%;
    min-height:100%;
    max-height:100%;
    margin-bottom: 60px;
  }
  .btn-footer {
    z-index: 10000;
    position: fixed;
    left: 0px;
    bottom: 0px;
    width: 100%;
    height: 60px;
    background-color: #eeeeee;
    .actions {
      text-align: center;
    }
    .btn {
      margin: 4px;
    }
  }
}
</style>